import * as React from 'react';
import styled from 'styled-components';

const CollapseContainer = styled.div<{ isOverflow: boolean }>`
    transition: height 0.4s;
    ${p => p.isOverflow ? 'overflow: hidden;' : ''}
`;

export default function Collapse(props: {
  isOpen: boolean
  children
}) {
	const ref = React.useRef<HTMLDivElement>(null);
	const mounted = React.useRef<boolean>(false);
	const [height, setHeight] = React.useState<number | undefined>(props.isOpen ? undefined : 0);
	const [animation, setAnimation] = React.useState<boolean>(false);

	React.useEffect(() => {
		if (!mounted.current) {
			mounted.current = true;
			return;
		}
		const content = ref.current;
		if (content == null) return;
		setAnimation(true);
		setHeight(content.offsetHeight);
		if (props.isOpen) return;
		const frame = requestAnimationFrame(() => requestAnimationFrame(() => setHeight(0)));
		return () => cancelAnimationFrame(frame);
	}, [props.isOpen]);

	return (
		<CollapseContainer
			style={{ height }}
			isOverflow={!props.isOpen || animation}
			onTransitionEnd={e => {
				if (e.target !== e.currentTarget) return;
				setAnimation(false);
				if (props.isOpen) setHeight(undefined);
			}}
		>
			<div ref={ref} style={{ display: 'flow-root' }}>
				{props.children}
			</div>
		</CollapseContainer>
	);
}
